import {
  Box,
  Button,
  InputLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useNotificationService } from "../../hooks/notification";
import LineProgress from "../ui-elements/line-progress";
import { textSty } from "../ui-elements/styles-input";
import { HandsFistIcon, UploadIcon } from "../ui-elements/svg-icons";

const UnAuthSignPetitionContainer = ({ data }: { data: any }) => {
  const { showNotification } = useNotificationService();
  const [comment, setComment] = useState("");

  // Construct full URL
  const baseUrl = window.location.origin;
  const additionalPath = `/posts?post_id=${data?.id}`;
  const fullShareLink = `${baseUrl}${additionalPath}`;
  // Copy function using Clipboard API
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(fullShareLink);
      showNotification("Link copied!", "success");
    } catch (err) {
      console.error("Failed to copy: ", err);
      showNotification("Failed to copy the link. Try again.", "error");
    }
  };

  const handle_sign = () => {
    showNotification("Kindly sign up to sign this petition!", "error");
    setComment("");
  };

  return (
    <Box
      sx={{
        mt: 2,
        borderRadius: "8px",
        minHeight: 250,
        height: "100%",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          border: "1px solid rgba(231, 235, 239, 1)",
          p: 3,
          pt: 2,
        }}
      >
        {/* progress */}
        <LineProgress
          current={Number(data?.signatures ?? 0)}
          total={Number(data?.target_signatures ?? 0)}
        />
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Stack>
            <Typography sx={textSty}>{data?.signatures}</Typography>
            <Typography sx={textSty}>Signatures</Typography>
          </Stack>
          <Stack>
            <Typography sx={textSty}>Goal</Typography>
            <Stack direction={"row"} spacing={1}>
              <Typography sx={textSty}>{data?.target_signatures}</Typography>
              <Typography sx={textSty}>Signature</Typography>
            </Stack>
          </Stack>
        </Stack>
        {/* {!!data?.target_representative && (
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            sx={{ my: 2 }}
          >
            <Typography sx={{ ...textSty, fontWeight: 500 }}>
              Directed to:
            </Typography>
            <Typography sx={{ ...textSty, fontWeight: 500 }}>
              {data?.target_representative}
            </Typography>
          </Stack> 
        )} */}
        <Stack sx={{ my: 2 }}>
          <Button
            variant="contained"
            startIcon={<UploadIcon />}
            onClick={copyToClipboard}
            sx={{
              backgroundColor: "#0A0B0A",
              borderRadius: "40px",
            }}
          >
            Share Petition
          </Button>
        </Stack>
        <Stack sx={{ my: 2 }}>
          <Typography color="black" sx={{ fontWeight: 500 }} variant="h5">
            Sign petition
          </Typography>
        </Stack>
        <Stack>
          <InputLabel
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              fontSize: 12,
              mb: 1,
            }}
          >
            Sign this petition (optional)
          </InputLabel>
          <TextField
            multiline
            rows={4}
            value={comment}
            onChange={(
              event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => setComment(event.target.value)}
          />
          <Stack direction={"column"} alignItems={"center"}>
            <Button
              variant="contained"
              onClick={handle_sign}
              color="primary"
              startIcon={<HandsFistIcon />}
              sx={{
                mt: 2,
                borderRadius: "40px",
                width: 300,
              }}
            >
              Continue
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default UnAuthSignPetitionContainer;
